import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

@Injectable({
  providedIn: 'root',
})
export class TranslationDomainService {
  constructor(private translateService: TranslocoService) {}

  translate(key: string): string {
    return this.translateService.translate(key);
  }

  translateObject<T extends object>(obj: T, properties: keyof T | (keyof T)[]) {
    if (Array.isArray(properties)) {
      let newObj = { ...obj };
      properties.forEach(property => {
        newObj = { ...newObj, [property]: this.translate(`${obj[property]}`) };
      });
      return newObj;
    }
    return { ...obj, [properties]: this.translate(`${obj[properties]}`) };
  }

  translateObjectArray<T extends object>(objArray: T[], property: keyof T | (keyof T)[]) {
    return objArray.map(obj => this.translateObject(obj, property));
  }
}
